import { gql } from '@/shared/graphql/generated/cache';
import { type LpAccountWithBalancesFragment } from '@/shared/graphql/generated/cache/graphql';

gql(/* GraphQL */ `
  fragment Pool on Pool {
    id
    baseAsset
    quoteAsset
    rangeOrderPrice
  }
`);

export type LpBalance = LpAccountWithBalancesFragment['balances']['nodes'][number];
export const getFilteredLpAccountsWithBalancesQuery = gql(/* GraphQL */ `
  query GetFilteredLpAccountsWithBalances($lpIdSs58: String) {
    lps: allLpAccounts(filter: { idSs58: { includesInsensitive: $lpIdSs58 } }) {
      totalCount
      nodes {
        ...LpAccountWithBalances
        arbitrumRefundAddress
        assethubRefundAddress
        bitcoinRefundAddress
        ethereumRefundAddress
        solanaRefundAddress
        tronRefundAddress
        bscRefundAddress
        openOrders
        strategy: tradingStrategiesByOwnerAccountIdSs58 {
          aggregates {
            sum {
              quoteAssetBalanceUsd
              baseAssetBalanceUsd
            }
          }
        }
      }
    }
    pools: allPools {
      nodes {
        ...Pool
      }
    }
  }
`);

export const getLpAccountWithBalances = gql(/* GraphQL */ `
  query GetLpAccountWithBalances($lpIdSs58: String!) {
    lpAccount: lpAccountByIdSs58(idSs58: $lpIdSs58) {
      ...LpAccountWithBalances
      arbitrumRefundAddress
      assethubRefundAddress
      bitcoinRefundAddress
      ethereumRefundAddress
      solanaRefundAddress
      tronRefundAddress
      bscRefundAddress
      openOrders
      strategy: tradingStrategiesByOwnerAccountIdSs58 {
        aggregates {
          sum {
            quoteAssetBalanceUsd
            baseAssetBalanceUsd
          }
        }
      }
    }
    pools: allPools {
      nodes {
        ...Pool
      }
    }
  }
`);

export const getFilteredLpAccountsWithBalancesV2Query = gql(/* GraphQL */ `
  query GetFilteredLpAccountsWithBalancesV2($filter: String) {
    lps: allLpAccounts(
      filter: {
        or: [
          { idSs58: { includesInsensitive: $filter } }
          { alias: { includesInsensitive: $filter } }
        ]
      }
    ) {
      totalCount
      nodes {
        ...LpAccountWithBalances
      }
    }
  }
`);
